import React, { createContext, ReactNode, useContext, useState } from 'react';

interface ErrorContextType {
  error: string | null;
  setError: (error: Error | string | null | unknown) => void;
  clearError: () => void;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [error, setErrorState] = useState<string | null>(null);

  const setError = (error: Error | string | null | unknown) => {
    if (error === null) {
      setErrorState(null);
    } else if (error instanceof Error) {
      setErrorState(error.message);
    } else if (typeof error === 'string') {
      setErrorState(error);
    } else {
      setErrorState(String(error));
    }
    console.error(error)
  };

  const clearError = () => setErrorState(null);

  return (
    <ErrorContext.Provider value={{ error, setError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = (): ErrorContextType => {
  const context = useContext(ErrorContext);
  if (context === undefined) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};
